export default {
  root: {
    class: [
      // Flex
      'flex items-center justify-center',

      // Shape
      'first:rounded-l-md',
      'last:rounded-r-md',
      'border-y',

      'last:border-r',
      'border-l',
      'border-r-0',

      // Space
      'p-3',

      // Size
      'min-w-[3rem]',

      // Color
      'bg-secondary-50 dark:bg-secondary-800',
      'text-secondary-600 dark:text-secondary-400',
      'border-secondary-300 dark:border-secondary-600'
    ]
  }
};
